import React, { useState, useEffect } from 'react';
import { Div, CenterRowDiv, RowDiv, Text } from 'styles';
import { Button, Icon, Img, InfoDiv, Input, LineText, SubTitle, Switch } from 'components';
import { useImmer } from 'use-immer';
import { Spinner } from 'components/loading/Spinner';
import { findIndex } from 'lodash';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { FormikInput } from 'components/form/input/FormikInput';
import useAlertContext from 'hooks/useAlertContext';
import houseActuatorService from 'services/house/house-actuator-service';
import Select from 'react-select';
import CustomLargeModal from 'components/dialogs/CustomLargeModal'; // 큰 모달 컴포넌트 import

const timeOptions = [
  { value: '', label: '시간 선택' },
  ...Array.from({ length: 24 }, (_, index) => ({
    value: `${index < 10 ? '0' : ''}${index}:00`,
    label: `${index < 10 ? '0' : ''}${index}:00`,
  })),
];

function ModalActuatorAcDetail({open, setOpen, title, id, sensorValue, airconData, afterCancel, afterSubmit}) {
  const { alert } = useAlertContext();

  const [loading, setLoading] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  
  const handleOnSubmit = async (values) => {
    
    setLoading(true);

    

     // 입력된 값 체크 로직 (유효성 검사 추가)
     let errorMessage = '';

     for (let i = 0; i < 5; i++) {
      if (values[`sectionCheckbox${i}`]) {
        // 시작 시간 확인
        if (!values[`startTime${i}`] || values[`startTime${i}`] === '시간 선택') {
          errorMessage += `구간 ${i + 1}의 시작 시간을 선택해 주세요.\n`;
        }
        // 종료 시간 확인 (주석으로 되어 있어 추가적인 조건 필요 시 추가 가능)
        // if (!values[`endTime${i}`]) {
        //   errorMessage += `구간 ${i + 1}의 종료 시간을 선택해 주세요.\n`;
        // }
        // 온도 입력 확인
        const tempInput = values[`temperatureInput${i}`];
        const tempRegex = /^-?\d+(\.\d+)?$/; // 숫자와 소수점만 허용하는 정규식

        if (!tempInput || tempInput === '-' || tempInput < 18 || tempInput > 30 || !tempRegex.test(tempInput)) {
          errorMessage += `구간 ${i + 1}의 온도 입력은 18에서 30 사이의 유효한 숫자여야 하며, 숫자와 소수점 이외의 문자가 포함될 수 없습니다.\n`;
        } else {
          // 입력값을 숫자 형태로 변환 후, 10을 곱해 정수화
          // tempInput = Math.round(parseFloat(tempInput) * 10);

          // formik.setFieldValue(`temperatureInput${i}`, tempInput);
        }
      }
    }

    if (errorMessage) {
      alert({
        type: 'alert',
        title: '입력 오류',
        content: errorMessage,
      });
      setLoading(false);
      return;
    }

    // 구간 정보 배열 생성
    const sections = [];

    for (let i = 0; i < 5; i++) {
      sections.push({
        section: `구간 ${i + 1}`,
        startTime: values[`startTime${i}`] || null,
        endTime: values[`endTime${i}`] || null,
        temperature: values[`temperatureInput${i}`] || null,
        isUsed: values[`sectionCheckbox${i}`] ? 1 : 0
      });
    }


    const actuatorId = id; // 액추에이터 ID
    const acPowerValue = values.powerValue; // 전원 값 (ON/OFF)

    let updateResponse = null;

    try {
      // updateHouseAcTemp 호출 (전원 값과 구간 배열 전달)
      updateResponse = await houseActuatorService.updateHouseAcTemp(actuatorId, acPowerValue, sections);
    } catch (e) {
      console.error(e);
    }

    if (updateResponse.state === 'success') {
      alert({
        type: 'alert',
        title: 'Info',
        content: '장비 제어가 정상 수행되었습니다.',
        okCallback: () => {
          setOpen(false);
      
          if (afterSubmit) {
            afterSubmit();
          }
        }
      })
    } else {
      let errorMessage = '장비 제어시 에러가 발생했습니다.';
      
      if (updateResponse && updateResponse.error_message) {
        errorMessage += `(${updateResponse.error_message})`;
      }

      alert({
        type: 'alert',
        title: 'Error',
        content: errorMessage
      })
    }

    setLoading(false);
  };
  
  const formik = useFormik({
    initialValues: {
      powerValue: null,
      sectionCheckbox0: false,
      sectionCheckbox1: false,
      sectionCheckbox2: false,
      sectionCheckbox3: false,
      sectionCheckbox4: false,
      startTime0: '',
      startTime1: '',
      startTime2: '',
      startTime3: '',
      startTime4: '',
      temperatureInput0: '',
      temperatureInput1: '',
      temperatureInput2: '',
      temperatureInput3: '',
      temperatureInput4: ''
    },
    onSubmit: (values) => {
      // 모든 값을 handleOnSubmit 함수에 넘깁니다.
      handleOnSubmit(values);
    }
  });

  useEffect(() => {
    if (!open || !airconData) {
      return;
    }
    
    const getActuatorDetail = async () => {
      setLoading(true);
      setCanEdit(false);

      const air = airconData[0]
      const time = airconData[1]
      const temp = airconData[2]
      const power = airconData[3]
      await formik.resetForm({ values: formik.initialValues });
      

      for (let i = 0; i < air.length; i++) {
        const dataArray = air[i]; 
        if (dataArray[0].sensor_value === 1) {
          const stationNumberMatch = dataArray[0].sensor_type.match(/STATION_(\d+)/);
          if (stationNumberMatch) {
            const stationNumber = parseInt(stationNumberMatch[1], 10);
            if (stationNumber >= 1 && stationNumber <= 5) {
              formik.setFieldValue(`sectionCheckbox${stationNumber - 1}`, true, true);
            }
          }
        }
      }
      for (let i = 0; i < temp.length; i++) {
        const dataArray = temp[i];
        if(dataArray.length !== 0){
          const tempData = dataArray[0].sensor_value;
          let formattedTempData = '';
          if (tempData === 0) {
            formattedTempData = 0.0;
          }else if (tempData > 0 && tempData < 10) {
            formattedTempData = parseFloat('0.' + tempData.toString());
          } else if (tempData >= 10) {
            formattedTempData = tempData.toString().slice(0, -1) + '.' + tempData.toString().slice(-1)
          } else {
            console.error(`Invalid sensor value: ${tempData}`);
          }
          formik.setFieldValue(`temperatureInput${i}`, formattedTempData, true);
        }
      }
      for (let i = 0; i < time.length; i++) {
        const dataArray = time[i];
        if (dataArray.length !== 0) {
          const timeData = dataArray[0].sensor_value;
          let formattedTimeData = '';
          if (timeData === 0) {
            formattedTimeData = "00:00";
          } else if (timeData >= 100 && timeData <= 2400) {
            const hour = Math.floor(timeData / 100);
            formattedTimeData = `${hour < 10 ? '0' : ''}${hour}:00`;
          } else {
            console.error(`Invalid sensor value: ${timeData}`);
          }
          formik.setFieldValue(`startTime${i}`, formattedTimeData, true);
        }
      }

      for (let i = 0; i < 5; i++) {
        if (!formik.values[`sectionCheckbox${i}`]) {
          // 사용 여부 체크되지 않은 경우에만 기본값 설정
          if (formik.values[`startTime${i}`] && formik.values[`startTime${i}`] !== '시간 선택') {
            formik.setFieldValue(`startTime${i}`, '시간 선택', true); // 시간 기본값 설정
          }
          if (formik.values[`temperatureInput${i}`] && formik.values[`temperatureInput${i}`] !== '-') {
            formik.setFieldValue(`temperatureInput${i}`, '-', true); // 온도 기본값 설정
          }
        }
      }
      

      
      if (power[0][0].sensor_value ===1) {
        formik.setFieldValue('powerValue', '1', true); // 'ON'으로 설정 (1: ON)
      } else if (power[0][0].sensor_value ===0){
        formik.setFieldValue('powerValue', '0', true); // 'OFF'로 설정 (0: OFF)
      }else{ 
        formik.setFieldValue('powerValue', '0', true); // 'OFF'로 설정 (0: OFF) 
      }

      setLoading(false);
      setCanEdit(true);
    }
    
    getActuatorDetail();
  }, [open])

  return (
    <CustomLargeModal open={open} setOpen={setOpen} title={title} cancel={() => {
      setOpen(false);
      if (afterCancel) {
        afterCancel();
      }
    }} 
    submit={() => {
      
      if (!loading && canEdit) {
        
        formik.submitForm();
      }
    }}
  >
    <form onSubmit={formik.handleSubmit}>
      <RowDiv $justifyContent="space-between" $alignItems="center" $flex={1} $marginBottom={24}>
        <Text>사용여부</Text>
        <Switch
          name="powerValue"
          value={formik.values.powerValue} // 불러온 값을 설정
          filters={{ type: formik.values.powerValue }}
          onChange={(name, value) => {
            formik.setFieldValue('powerValue', value, true);
          }}
          list={[
            { name: 'ON', val: '1' },
            { name: 'OFF', val: '0' },
          ]}
        />
      </RowDiv>

      {/* 나머지 모달 내용 */}
      <Div $flex={1}>
        {/* 각 구간에 체크박스, 라벨, 시작/종료 시간 선택, 온도 입력 필드를 한 줄로 추가 */}
        {[...Array(5)].map((_, index) => (
          
          <RowDiv key={index} $justifyContent="space-between" $alignItems="center" $marginTop={16}>
            {/* 구간 체크박스 */}
            <input
              type="checkbox"
              name={`sectionCheckbox${index}`}
              checked={formik.values[`sectionCheckbox${index}`]}
              onChange={(e) => {
                const isChecked = e.target.checked;
                formik.setFieldValue(`sectionCheckbox${index}`, e.target.checked)

                if (isChecked) {
                  // 체크박스가 체크될 때, 값이 없을 경우 기본값 설정
                  if (!formik.values[`startTime${index}`]) {
                    formik.setFieldValue(`startTime${index}`, '시간 선택');
                  }
                  if (!formik.values[`temperatureInput${index}`]) {
                    formik.setFieldValue(`temperatureInput${index}`, '');
                  }
                }else {
                  // 체크박스가 해제되었을 때 기본값 설정
                  formik.setFieldValue(`startTime${index}`, '');
                  formik.setFieldValue(`temperatureInput${index}`, '-');
                }
              }}
            />

            {/* 구간 라벨 */}
            <Text>{`구간 ${index + 1}`}</Text>

            {/* 시작 시간 셀렉트 박스 */}
            <Select
              name={`startTime${index}`}
              value={timeOptions.find(option => option.value === formik.values[`startTime${index}`]) || { value: '', label: '시간 선택' }} // formik의 값과 일치하는 옵션 찾기
              onChange={(selectedOption) => formik.setFieldValue(`startTime${index}`, selectedOption.value)} // 선택된 값 설정
              options={timeOptions}
              placeholder="시작 시간"
              $width="20%"
              isDisabled={!formik.values[`sectionCheckbox${index}`]}
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: '130px', // 모든 셀렉트 박스의 가로 길이를 동일하게 고정합니다.
                }),
                control: (provided) => ({
                  ...provided,
                  width: '130px', // 셀렉트 박스의 컨트롤 부분의 길이를 동일하게 고정합니다.
                }),
                menu: (provided) => ({
                  ...provided,
                  maxHeight: 150, // 드롭다운의 최대 높이 설정
                  overflowY: 'auto', // 필요시 스크롤 생성
                }),
                menuList: (provided) => ({
                  ...provided,
                  maxHeight: 150, // 드롭다운 리스트의 최대 높이 설정
                }),
              }}
            />

            {/* 종료 시간 셀렉트 박스 */}
            {/* <Select
              name={`endTime${index}`}
              value={timeOptions.find(option => option.value === formik.values[`endTime${index}`])} // formik의 값과 일치하는 옵션 찾기
              onChange={(selectedOption) => formik.setFieldValue(`endTime${index}`, selectedOption.value)} // 선택된 값 설정
              options={timeOptions}
              placeholder="종료 시간"
              $width="20%"
              styles={{
                menu: (provided) => ({
                  ...provided,
                  maxHeight: 150, // 드롭다운의 최대 높이 설정
                  overflowY: 'auto', // 필요시 스크롤 생성
                }),
                menuList: (provided) => ({
                  ...provided,
                  maxHeight: 150, // 드롭다운 리스트의 최대 높이 설정
                }),
              }}
            /> */}

            {/* 온도 입력 필드 */}
            <FormikInput
              type="text"
              name={`temperatureInput${index}`}
              value={formik.values[`temperatureInput${index}`] || ''}
              placeholder="온도 입력"
              unit="°C"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              $width="20%"
              step="0.1"
              disabled={!formik.values[`sectionCheckbox${index}`]}
            />
          </RowDiv>
        ))}
      </Div>

      {loading && (
        <CenterRowDiv $justifyContent="center" $marginTop="20px">
          <Spinner $width={25} $height={25} />
        </CenterRowDiv>
      )}
    </form>
  </CustomLargeModal>
  )
}

export default ModalActuatorAcDetail
